import React from "react";
import {Radio} from "antd";
import { Form } from '@ant-design/compatible';

import './RadioGroup.scss';
import PropTypes from "prop-types";

const RadioGroup = ({ name, rules, initialValue, options, form, formItemStyle, isRadioButton = true }) => {
  return (
    <Form.Item style={formItemStyle}>
      {form.getFieldDecorator(name, { rules, initialValue: initialValue })(
        <Radio.Group >
          {options.map(option => (
            isRadioButton ? 
              <Radio.Button
                className="radio-group-button"
                style={{margin: "0 5px", padding: "0 10px"}}
                key={option.value}
                value={option.value}
              >
                <b>{option.text}</b>
              </Radio.Button>
              :
              <Radio
                key={option.value}
                value={option.value}
              >
                <b>{option.text}</b>
              </Radio>
          ))}
        </Radio.Group>
      )}
    </Form.Item>
  )
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.array,
  options: PropTypes.array,
  form: PropTypes.object.isRequired,
  formItemStyle: PropTypes.object,
}

export default RadioGroup
